module.exports = __webpack_public_path__ + "img/reorder.b125a05c.svg";